import { ACUTE_GHVD_CLINICAL_SCORING } from "./configList/acuteGhvdClinicalScoring";
import { ALDETRE_SCORE } from "./configList/aldetreScore";
import { CAN_SCALE } from "./configList/canScale";
import { CAPRINI_RISK_ASSESSMENT } from "./configList/capriniRiskAssessment";
import { CASUS_SCORE } from "./configList/casusScore";
import { EDINEBURGH_DEPT_SCALE } from "./configList/edineburghDeptScale";
import { EURO_SCORE } from "./configList/euroScore";
import { GLASGOW_SCORE } from "./configList/glasgowScore";
import { IMPROVE_BLEEDING_RISK } from "./configList/improveBleedingRisk";
import { NURSE_APPLICATION } from "./configList/nurseApplication";
import { PAIN_ASSESSMENT_SCALE } from "./configList/painAssessmentScale";
import { PEDIATRIC_TRAUMA_SCORE } from "./configList/pediatricTraumaScore";
import { PRISM_SCORE } from "./configList/prismScore";
import { SAPS2_SCORE } from "./configList/saps2Score";
import { SNAP_II_SCORE } from "./configList/snap2Score";
import { SOFA_SCORE } from "./configList/sofaScore";
import { IMPROVE_VTE_RISK_ASSESSMENT } from "./configList/improveVteRiskAssetment";
import { NEOMOD_SCORE } from "./configList/neomodScore";
import { VITAL_SIGNS } from "./configList/vitalSigns";
import { PATIENT_MONITORING } from "./configList/patientMonitoring";
import { FALL_RISK_HARIZMI } from "./configList/fallRiskHarizmi";
import { FALL_RISK_ITAKI } from "./configList/fallRiskItaki";
import { FLUID_BALANCE } from './configList/fluidBalance';
import { VTE_RISK_FACTOR_EVALUATION } from "./configList/vteRiskFactorEvaluation";
import { BASI_BRADEN_RISK_SCORE, BASI_BRADEN_RISK_SCORE_Q, BASI_BRADEN_RISK_SCORE_BBQ } from "./configList/basiBradenRiskScore";
import { NEWBORN_SKIN_RISK_ASSESSMENT } from "./configList/newbornSkinRiskAssessment";
import { MC_NUTRITIONAL_RISK_SCORE } from "./configList/nutritionalRiskScore";
import { PARTOGRAPH } from "./configList/partograph";

export type CardField = {
  field: string;
  headerName: string;
  flex: number;
  computed?: boolean;
  calculate?: (row: any) => number;
  type?: any;
};

export interface BaseCardData {
  title: string;
  masterTableName?: string;
  tableName: string;
  columnName?: string;
  columnValue?: number;
  formData: Record<string, any>;
  fields: CardField[];
  rows: any[];
  mcpConfig: Record<string, { mcpId: number; field: string; scoreField: string }>;
  extraMcpIds?: number[];
}

export const CARD_DATA = {
  GLASGOW_SCORE,
  IMPROVE_BLEEDING_RISK,
  EURO_SCORE,
  CASUS_SCORE,
  ALDETRE_SCORE,
  ACUTE_GHVD_CLINICAL_SCORING,
  EDINEBURGH_DEPT_SCALE,
  CAPRINI_RISK_ASSESSMENT,
  SNAP_II_SCORE,
  PEDIATRIC_TRAUMA_SCORE,
  SOFA_SCORE,
  PRISM_SCORE,
  SAPS2_SCORE,
  PAIN_ASSESSMENT_SCALE,
  NURSE_APPLICATION,
  CAN_SCALE,
  IMPROVE_VTE_RISK_ASSESSMENT,
  NEOMOD_SCORE,
  VITAL_SIGNS,
  PATIENT_MONITORING,
  FALL_RISK_HARIZMI,
  FALL_RISK_ITAKI,
  FLUID_BALANCE,
  VTE_RISK_FACTOR_EVALUATION,
  BASI_BRADEN_RISK_SCORE,
  BASI_BRADEN_RISK_SCORE_Q,
  BASI_BRADEN_RISK_SCORE_BBQ,
  NEWBORN_SKIN_RISK_ASSESSMENT,
  NUTRITIONAL_RISK_SCORE: MC_NUTRITIONAL_RISK_SCORE,

  PARTOGRAPH,
};

export const getCardData = (cardType: string): any => {
  switch (cardType) {
    case "GLASGOW_SCORE":
      return CARD_DATA.GLASGOW_SCORE;
    case "EURO_SCORE":
      return CARD_DATA.EURO_SCORE;
    case "CASUS_SCORE":
      return CARD_DATA.CASUS_SCORE;
    case "ALDETRE_SCORE":
      return CARD_DATA.ALDETRE_SCORE;
    case "ACUTE_GHVD_CLINICAL_SCORING":
      return CARD_DATA.ACUTE_GHVD_CLINICAL_SCORING;
    case "EDINEBURGH_DEPT_SCALE":
      return CARD_DATA.EDINEBURGH_DEPT_SCALE;
    case "CAPRINI_RISK_ASSESSMENT":
      return CARD_DATA.CAPRINI_RISK_ASSESSMENT;
    case "SNAP_II_SCORE":
      return CARD_DATA.SNAP_II_SCORE;
    case "PEDIATRIC_TRAUMA_SCORE":
      return CARD_DATA.PEDIATRIC_TRAUMA_SCORE;
    case "SOFA_SCORE":
      return CARD_DATA.SOFA_SCORE;
    case "PAIN_ASSESSMENT_SCALE":
      return CARD_DATA.PAIN_ASSESSMENT_SCALE;
    case "NURSE_APPLICATION":
      return CARD_DATA.NURSE_APPLICATION;
    case "IMPROVE_BLEEDING_RISK":
      return CARD_DATA.IMPROVE_BLEEDING_RISK;
    case "IMPROVE_VTE_RISK_ASSESSMENT":
      return CARD_DATA.IMPROVE_VTE_RISK_ASSESSMENT;
    case "PRISM_SCORE":
      return CARD_DATA.PRISM_SCORE;
    case "SAPS2_SCORE":
      return CARD_DATA.SAPS2_SCORE;
    case "CAN_SCALE":
      return CARD_DATA.CAN_SCALE;
    case "NEOMOD_SCORE":
      return CARD_DATA.NEOMOD_SCORE;
    case "VITAL_SIGNS":
      return CARD_DATA.VITAL_SIGNS;
    case "PATIENT_MONITORING":
      return CARD_DATA.PATIENT_MONITORING;
    case "FALL_RISK_HARIZMI":
      return CARD_DATA.FALL_RISK_HARIZMI;
    case "FALL_RISK_ITAKI":
      return CARD_DATA.FALL_RISK_ITAKI;
    case 'FLUID_BALANCE':
      return CARD_DATA.FLUID_BALANCE;
    case "VTE_RISK_FACTOR_EVALUATION":
      return CARD_DATA.VTE_RISK_FACTOR_EVALUATION;
    case "BASI_BRADEN":
    case "BASI_BRADEN_RISK_SCORE":
      return CARD_DATA.BASI_BRADEN_RISK_SCORE;
    case "BASI_BRADEN_RISK_SCORE_Q":
      return CARD_DATA.BASI_BRADEN_RISK_SCORE_Q;
    case "BASI_BRADEN_RISK_SCORE_BBQ":
      return CARD_DATA.BASI_BRADEN_RISK_SCORE_BBQ;
    case "NEWBORN_SKIN_RISK_ASSESSMENT":
      return CARD_DATA.NEWBORN_SKIN_RISK_ASSESSMENT;
    case "MCNutritionalRiskScore":
      return CARD_DATA.NUTRITIONAL_RISK_SCORE;
    case "PARTOGRAPH":
      return CARD_DATA.PARTOGRAPH;
    default:
      return null;
  }
};
